<template lang="pug">
.copyright.caption 
  | Copyright {{year}} Matthieu Lavanchy
  i(v-if="credits", v-show="!showCredits" @click="showCredits = !showCredits") . Site Credits
  br
  span(v-show="showCredits") 
    | Site designed by 
    a(href="http://spencerfenton.co.uk", target="_blank") Spencer Fenton
    |  & developed by 
    a(href="http://everettwilliams.info", target="_blank") Everett Williams
</template>

<script>
export default {
  name: 'Copyright',
  props: {
    credits: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showCredits: false
    }
  },
  computed: {
    year () {
      const date = new Date()
      return date.getFullYear()
    }
  }
}
</script>

<style lang="scss" scoped>
.copyright{
  i{
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// Copyright.vue?6ed23308